import React, { useEffect, useState } from 'react'
import QuestMap from './quest/QuestMap'

export default function PathMapView({
  sections,
  timelineUnit,
  courseId,
  courseName,
  onLaunch,
  onOpenHomework,
  onOpenEvaluation,
  onOpenGrowth,
  selectedKey: controlledKey,
  onSelectItem,
}) {
  const [internalKey, setInternalKey] = useState(null)
  const selectedKey = controlledKey !== undefined ? controlledKey : internalKey

  useEffect(() => {
    setInternalKey(null)
  }, [sections])

  const handleSelect = (item) => {
    if (item?.key && item.key === selectedKey) {
      if (controlledKey === undefined) setInternalKey(null)
      onSelectItem?.(null)
      return
    }
    if (controlledKey === undefined) {
      setInternalKey(item?.key || null)
    }
    onSelectItem?.(item)
  }

  const handleClose = () => {
    if (controlledKey === undefined) {
      setInternalKey(null)
    }
    onSelectItem?.(null)
  }

  return (
    <div className="path-map-view">
      <QuestMap
        sections={sections}
        timelineUnit={timelineUnit}
        courseId={courseId}
        courseName={courseName}
        selectedKey={selectedKey}
        onSelectItem={handleSelect}
        onCloseDetail={handleClose}
        onLaunch={onLaunch}
        onOpenHomework={onOpenHomework}
        onOpenEvaluation={onOpenEvaluation}
        onOpenGrowth={onOpenGrowth}
      />
    </div>
  )
}
